module.exports = __webpack_public_path__ + "static/media/link-expired.bd3b2184.svg";